import React from "react";
import styled from "styled-components";

export default styled.img`
    display: block;
    margin: 0 auto;
    margin-bottom: 5px;
    
    transform: translate(-50%, -50%);
    
    top: 42%;
    position: absolute;
    left: 50%;
    max-width: 36% !important;
    
    
    ${(props) => (props.open ? {
    'filter': 'invert(1) grayscale(1) brightness(6)'
} : '')}
`;

